module.exports = __webpack_public_path__ + "static/media/2.619d6c2c.jpg";